import { useSelector } from 'react-redux';
import { hearingStatusByHearingIdSelector } from '../../../../../../features/apiFeatures/hearingStatusSlice';
import { isUpdatingHearingSelector } from '../../../../../../features/pageFeatures/createHearingPageSlice';
import { allInvitationSourcesSelector } from '../../../../../../features/apiFeatures/invitationSourceSlice';
import { allInvitationSourceMappingsByHearingIdSelector } from '../../../../../../features/apiFeatures/invitationSourceMappingSlice';
import { allUsersInRoleByHearingIdSelector } from '../../../../../../features/apiFeatures/userSlice';
import {
  HEARINGROLE_INVITEE,
  NOTIFICATIONQUEUE_TYPE,
  NOTIFICATIONTYPE_INVITED_TO_HEARING,
} from '../../../../../../constants/api';
import { allCompaniesInRoleByHearingIdSelector } from '../../../../../../features/apiFeatures/companySlice';
import { allUserHearingRolesWithRoleByHearingIdSelector } from '../../../../../../features/apiFeatures/userHearingRoleSlice';
import { allCompanyHearingRolesWithRoleByHearingIdSelector } from '../../../../../../features/apiFeatures/companyHearingRoleSlice';
import { invitationGroupsByHearingTypeIdSelector } from '../../../../../../features/apiFeatures/invitationGroupSlice';
import { hearingTypeByHearingIdSelector } from '../../../../../../features/apiFeatures/hearingTypeSlice';
import {
  getEntityId,
  getRelId,
} from '../../../../../../features/helpers/apiHelpers';
import { allNotificationsWithTypeForHearingIdSelector } from '../../../../../../features/apiFeatures/notificationSlice';
import { notificationQueuesByIdsSelector } from '../../../../../../features/apiFeatures/notificationQueueSlice';
import { useMemo } from 'react';

export const useData = (hearingId) => {
  const hearingType = useSelector(hearingTypeByHearingIdSelector(hearingId));

  const hearingStatus = useSelector(
    hearingStatusByHearingIdSelector(hearingId),
  );
  const isUpdatingHearing = useSelector(isUpdatingHearingSelector);
  const invitationSources = useSelector(allInvitationSourcesSelector);
  const invitationSourceMappings = useSelector(
    allInvitationSourceMappingsByHearingIdSelector(hearingId),
  );
  const invitedUsers = useSelector(
    allUsersInRoleByHearingIdSelector(HEARINGROLE_INVITEE, hearingId),
  );
  const invitedCompanies = useSelector(
    allCompaniesInRoleByHearingIdSelector(HEARINGROLE_INVITEE, hearingId),
  );
  const invitedUserHearingRoles = useSelector(
    allUserHearingRolesWithRoleByHearingIdSelector(
      HEARINGROLE_INVITEE,
      hearingId,
    ),
  );
  const invitedCompanyHearingRoles = useSelector(
    allCompanyHearingRolesWithRoleByHearingIdSelector(
      HEARINGROLE_INVITEE,
      hearingId,
    ),
  );
  const invitationGroupsForHearingType = useSelector(
    invitationGroupsByHearingTypeIdSelector(getEntityId(hearingType)),
  );

  const invitationNotifications = useSelector(
    allNotificationsWithTypeForHearingIdSelector(
      NOTIFICATIONTYPE_INVITED_TO_HEARING,
      hearingId,
    ),
  );

  const notificationQueueIds = useMemo(
    () =>
      invitationNotifications.map((notification) =>
        getRelId(notification, NOTIFICATIONQUEUE_TYPE),
      ),
    [invitationNotifications],
  );

  const invitationNotificationQueues = useSelector(
    notificationQueuesByIdsSelector(notificationQueueIds),
  );

  return {
    hearingStatus,
    isUpdatingHearing,
    invitationSources,
    invitationSourceMappings,
    invitedUsers,
    invitedCompanies,
    invitedUserHearingRoles,
    invitedCompanyHearingRoles,
    invitationGroupsForHearingType,
    invitationNotifications,
    invitationNotificationQueues,
  };
};
